import { useTranslation } from 'react-i18next';

import {
    Button,
    Center,
    HighlightedCard,
    Stack,
    Subtitle1,
    Subtitle2,
} from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import type { PrescriptionOffer } from '../../../../hooks/use-prescription-offers';

import { PriorAuthSelfPayModal } from './PriorAuthSelfPayModal';

export type SelectSelfPayPathCardProps = {
    offer: PrescriptionOffer | undefined;
};

export const SelectSelfPayPathCard = ({
    offer,
}: SelectSelfPayPathCardProps) => {
    const { t } = useTranslation('lilly');
    const [opened, { toggle }] = useDisclosure();

    const line1 =
        offer?.headlinePriceType === 'Incentive' ||
        offer?.headlinePriceType === 'CashAssistance'
            ? t('fill.insurance.pathSelect.cards.selfPay.line1')
            : t('fill.insurance.pathSelect.cards.selfPay.line1NoCard');
    const line2 =
        !offer || offer.headlinePriceType === 'SelfPayPriceAtPharmacy'
            ? t('fill.pathSelect.cards.line2NoPrice')
            : offer.headlinePriceType === 'Incentive' ||
                offer.headlinePriceType === 'CashAssistance'
              ? t('fill.pathSelect.cards.line2', {
                    price: offer.patientCost,
                })
              : t('fill.pathSelect.cards.line2PriceOnly', {
                    price: offer.patientCost,
                });

    return (
        <>
            <HighlightedCard
                fullWidthFooter
                pinFooter
                fullHeight
                data-testid="path-select-card-self-pay"
                header={
                    <Center data-testid="path-select-card-self-pay-title">
                        {t('fill.insurance.pathSelect.cards.selfPay.heading')}
                    </Center>
                }
                footer={
                    <Button fullWidth variant="outline" onClick={toggle}>
                        {t('fill.insurance.pathSelect.cards.selfPay.button')}
                    </Button>
                }
            >
                <Stack gap="md">
                    <Subtitle2>{line1}</Subtitle2>
                    <Subtitle1>{line2}</Subtitle1>
                </Stack>
            </HighlightedCard>
            <PriorAuthSelfPayModal isOpen={opened} close={toggle} />
        </>
    );
};
